import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material"
import FileTree from "../../../../../components/FileTree"
import { useQuery } from "react-query";
import axiosClient from "../../../../../lib/axios";
import { IDataArquivosCopynorte, IDataArquivosCopynorteArquivo } from "../../../../../types/api/bpm/pesquisar-arquivos-copynorte";
import LoadingApiQuery from "../../../../../components/LoadingApiQuery";

export default function DialogVisualizacaoArquivos({
    open,
    clienteInfo,
    handleClose
}: DialogVisualizacaoArquivosProps) {

    //queries e mutations
    const { data, isLoading } = useQuery({
        queryKey: ['dialog-pesquisar-arquivos-copynorte', clienteInfo],
        queryFn: () => axiosClient.get("/pesquisar-arquivos-copynorte", {
            params: {
                codigo: clienteInfo.codigo,
                tipo: clienteInfo.tipo
            }
        }),
        keepPreviousData: false
    });
    const dataArquivosCopynorte: IDataArquivosCopynorte = data?.data
    //

    //funções manipuladoras
    function converterParaArray(arquivo: IDataArquivosCopynorteArquivo[], parentId?: string): { id: string; name: string; children?: any[] }[] {
        return arquivo.map((arq) => {
            const obj: { id: string; name: string; children?: any[] } = { id: arq.id, name: arq.nome + `[${arq.tipo}]` };
            if (arq.filhos && arq.filhos.length > 0) {
                obj.children = converterParaArray(arq.filhos, arq.id);
            }
            return obj;
        });
    }
    //

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            fullWidth
        >
            <DialogTitle>
                Visualizar documentos existentes
            </DialogTitle>

            <DialogContent>
                {
                    isLoading &&
                    <LoadingApiQuery />
                }

                {
                    !isLoading &&
                    <FileTree data={converterParaArray([dataArquivosCopynorte])} />
                }
            </DialogContent>

            <DialogActions>
                <Button
                    onClick={handleClose}
                >
                    Fechar
                </Button>
            </DialogActions>
        </Dialog>
    )
}

interface DialogVisualizacaoArquivosProps {
    open: boolean,
    clienteInfo: {
        codigo: string,
        tipo: string
    }
    handleClose: () => void
}